import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateParticipantTaskTemplate } from '../mutations/updateParticipantTaskTemplate.mutation';
import type {
  UpdateParticipantTaskTemplateMutation,
  UpdateParticipantTaskTemplateMutationVariables,
} from '../types';

export const useUpdateParticipantTaskTemplateMutation = (
  options?: MutationOptions<
    UpdateParticipantTaskTemplateMutation,
    UpdateParticipantTaskTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantTaskTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantTaskTemplates'),
      });
    },
  });
};
